import { render } from "./dma.vue?vue&type=template&id=0b49aa64&scoped=true"
import script from "./dma.vue?vue&type=script&lang=js"
export * from "./dma.vue?vue&type=script&lang=js"

import "./dma.vue?vue&type=style&index=0&id=0b49aa64&lang=scss&scoped=true"

import exportComponent from "D:\\AAA-project-LK\\loginform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b49aa64"]])

export default __exports__